import { Lookup } from '@/api/admin/lookup';
import { Button } from '@/components/ui/button';
import { Checkbox } from '@/components/ui/checkbox';
import { ColumnDef } from '@tanstack/react-table';
import { ArrowUpDown } from 'lucide-react';
import { UpdateLookup } from './sheet-update';

export const columns: ColumnDef<Lookup>[] = [
    {
        accessorKey: 'transformLookupId',
        header: ({ column }) => (
            <div className="flex justify-center">
                <Button
                    variant="ghost"
                    onClick={() => column.toggleSorting(column.getIsSorted() === 'asc')}
                >
                    Id
                    <ArrowUpDown />
                </Button>
            </div>
        ),
        cell: ({ row }) => {
            return (
                <div className="flex justify-center whitespace-nowrap font-medium">
                    {row.original.transformLookupId}
                </div>
            );
        },
    },
    {
        accessorKey: 'lookupType',
        header: ({ column }) => (
            <div className="flex justify-center">
                <Button
                    variant="ghost"
                    onClick={() => column.toggleSorting(column.getIsSorted() === 'asc')}
                >
                    Lookup Type
                    <ArrowUpDown />
                </Button>
            </div>
        ),
        cell: ({ row }) => {
            return (
                <div className="flex justify-center whitespace-nowrap font-medium">
                    {row.original.lookupType}
                </div>
            );
        },
    },
    {
        accessorKey: 'lookupValue',
        header: ({ column }) => (
            <div className="flex justify-center">
                <Button
                    variant="ghost"
                    onClick={() => column.toggleSorting(column.getIsSorted() === 'asc')}
                >
                    Lookup Value
                    <ArrowUpDown />
                </Button>
            </div>
        ),
        cell: ({ row }) => {
            return (
                <div className="flex justify-center whitespace-nowrap font-medium">
                    {row.original.lookupValue}
                </div>
            );
        },
    },
    {
        accessorKey: 'sourceValue',
        header: ({ column }) => (
            <div className="flex justify-center">
                <Button
                    variant="ghost"
                    onClick={() => column.toggleSorting(column.getIsSorted() === 'asc')}
                >
                    Source Value
                    <ArrowUpDown />
                </Button>
            </div>
        ),
        cell: ({ row }) => {
            return (
                <div className="flex justify-center whitespace-nowrap font-medium">
                    {row.original.sourceValue}
                </div>
            );
        },
    },
    {
        accessorKey: 'lookupDescription',
        header: ({ column }) => (
            <div className="flex justify-center">
                <Button
                    variant="ghost"
                    onClick={() => column.toggleSorting(column.getIsSorted() === 'asc')}
                >
                    Lookup Description
                    <ArrowUpDown />
                </Button>
            </div>
        ),
        cell: ({ row }) => {
            return (
                <div className="flex justify-center whitespace-nowrap font-medium">
                    {row.original.lookupDescription}
                </div>
            );
        },
    },
    {
        accessorKey: 'optionalLookupValue',
        header: ({ column }) => (
            <div className="flex justify-center">
                <Button
                    variant="ghost"
                    onClick={() => column.toggleSorting(column.getIsSorted() === 'asc')}
                >
                    Optional Lookup Value
                    <ArrowUpDown />
                </Button>
            </div>
        ),
        cell: ({ row }) => {
            return (
                <div className="flex justify-center whitespace-nowrap font-medium">
                    {row.original.optionalLookupValue}
                </div>
            );
        },
    },
    {
        accessorKey: 'optionalLookupValueB',
        header: ({ column }) => (
            <div className="flex justify-center">
                <Button
                    variant="ghost"
                    onClick={() => column.toggleSorting(column.getIsSorted() === 'asc')}
                >
                    Optional Lookup Value B
                    <ArrowUpDown />
                </Button>
            </div>
        ),
        cell: ({ row }) => {
            return (
                <div className="flex justify-center whitespace-nowrap font-medium">
                    {row.original.optionalLookupValueB}
                </div>
            );
        },
    },
    {
        accessorKey: 'databaseInstanceName',
        header: ({ column }) => (
            <div className="flex justify-center">
                <Button
                    variant="ghost"
                    onClick={() => column.toggleSorting(column.getIsSorted() === 'asc')}
                >
                    Database Instance
                    <ArrowUpDown />
                </Button>
            </div>
        ),
        cell: ({ row }) => {
            return (
                <div className="flex justify-center whitespace-nowrap font-medium">
                    {row.original.databaseInstanceName}
                </div>
            );
        },
    },
    {
        accessorKey: 'expired',
        header: ({ column }) => (
            <div className="flex justify-center">
                <Button
                    variant="ghost"
                    onClick={() => column.toggleSorting(column.getIsSorted() === 'asc')}
                >
                    Expired
                    <ArrowUpDown />
                </Button>
            </div>
        ),
        cell: ({ row }) => {
            return (
                <div className="flex justify-center">
                    <Checkbox checked={!!row.original.expired} disabled />
                </div>
            );
        },
    },
    {
        id: 'actions',
        cell: ({ row }) => (
            <div>
                <UpdateLookup lookup={row.original} />
            </div>
        ),
    },
];
